import axios, { AxiosInstance } from 'axios';
import { getType } from 'typesafe-actions';

import store from '../../app/store';
// Cookie-based auth only. No token storage in JS. No Authorization header needed.
import { spinnerStart, spinnerStop } from '../actions/spinner.actions';
import { logoutActions } from '../../features/account/login/login.actions';
import { showNotification } from '../actionCreators/dispatchNotification';


export const startSpinner = () => {
  store.dispatch({ type: getType(spinnerStart) });
}

export const stopSpinner = () => {
  store.dispatch({ type: getType(spinnerStop) });
}

function apiClient(): AxiosInstance {
  let client = axios.create({
    baseURL: "/api/",
    headers: {
      'Content-Type': 'application/json'//,
    },
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    withCredentials: true,  // Ensure cookies (including HttpOnly auth cookie) are sent with requests
    // For same-origin requests, cookies are sent automatically, but this ensures it works for cross-origin too
    // (when CORS allows credentials)
  });

  client.interceptors.request.use(async (config) => {
    await startSpinner();
    // SECURITY: Do not send Authorization header - authentication is via HttpOnly cookie (MHA_JWT_AUTH)
    // Cookies are automatically sent by browser for same-origin requests
    // XSRF token header is handled automatically by Axios (xsrfCookieName/xsrfHeaderName config)

    return config;
  }, error => {
    return Promise.reject(error);
  });

  client.interceptors.response.use(
    async response => {
      if (response.status === 401) {
        // Don't trigger logout on 401 from /account/current-token - it's expected when not authenticated
        // This endpoint is used for auth initialization and may legitimately return 401
        const url = response.config?.url || '';
        if (!url.includes('/account/current-token')) {
          store.dispatch({ type: getType(logoutActions.request) });
          showNotification('Your session timed out.', 'error');
        }
      }
      setTimeout(async () => { await stopSpinner(); }, 500);
      return response
    },
    async error => {
      // Don't trigger logout on 401 from /account/current-token - it's expected when not authenticated
      // This endpoint is used for auth initialization and may legitimately return 401
      if (error.response?.status === 401) {
        const url = error.config?.url || '';
        if (!url.includes('/account/current-token')) {
          store.dispatch({ type: getType(logoutActions.request) });
          showNotification('Your session timed out.', 'error');
        }
      }
      await stopSpinner();
      return Promise.reject(error);
    }
  );

  return client;
}



export default apiClient;
